export const ADD_EMPLOYEE = 'admin/ADD_DATA_ITEM';
export const ADD_EMPLOYEE_SUCCESS = 'admin/ADD_DATA_ITEM_SUCCESS';
export const ADD_EMPLOYEE_FAILURE = 'admin/ADD_DATA_ITEM_FAILURE';

export const BULK_ADD_EMPLOYEES = 'admin/BULK_ADD_DATA_ITEM';
export const BULK_ADD_EMPLOYEES_SUCCESS = 'admin/BULK_ADD_DATA_ITEM_SUCCESS';
export const BULK_ADD_EMPLOYEES_FAILURE = 'admin/BULK_ADD_DATA_ITEM_FAILURE';

export const REMOVE_EMPLOYEE = 'admin/REMOVE_DATA_ITEM';
export const REMOVE_EMPLOYEE_SUCCESS = 'admin/REMOVE_DATA_ITEM_SUCCESS';
export const REMOVE_EMPLOYEE_FAILURE = 'admin/REMOVE_DATA_ITEM_FAILURE';

export const UPDATE_EMPLOYEE = 'admin/UPDATE_DATA_ITEM';
export const UPDATE_EMPLOYEE_SUCCESS = 'admin/UPDATE_DATA_ITEM_SUCCESS';
export const UPDATE_EMPLOYEE_FAILURE = 'admin/UPDATE_DATA_ITEM_FAILURE';

export const ADD_CATEGORY = 'admin/rewards/ADD_DATA_ITEM';
export const ADD_CATEGORY_SUCCESS = 'admin/rewards/ADD_DATA_ITEM_SUCCESS';
export const ADD_CATEGORY_FAILURE = 'admin/rewards/ADD_DATA_ITEM_FAILURE';

export const REMOVE_CATEGORY = 'admin/rewards/REMOVE_DATA_ITEM';
export const REMOVE_CATEGORY_SUCCESS = 'admin/rewards/REMOVE_DATA_ITEM_SUCCESS';
export const REMOVE_CATEGORY_FAILURE = 'admin/rewards/REMOVE_DATA_ITEM_FAILURE';

export const UPDATE_CATEGORY = 'admin/rewards/UPDATE_DATA_ITEM';
export const UPDATE_CATEGORY_SUCCESS = 'admin/rewards/UPDATE_DATA_ITEM_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'admin/rewards/UPDATE_DATA_ITEM_FAILURE';

export const FETCH_ROLE_PERMISSIONS = 'admin/FETCH_ROLE_PERMISSIONS';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'admin/FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAILURE = 'admin/FETCH_ROLE_PERMISSIONS_FAILURE';

export const FETCH_PERMISSIONS = 'admin/FETCH_PERMISSIONS';
export const FETCH_PERMISSIONS_SUCCESS = 'admin/FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'admin/FETCH_PERMISSIONS_FAILURE';

export const ADD_ROLE = 'admin/ADD_ROLE';
export const ADD_ROLE_SUCCESS = 'admin/ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'admin/ADD_ROLE_FAILURE';

export const UPDATE_ROLE = 'admin/UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'admin/UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'admin/UPDATE_ROLE_FAILURE';

export const DELETE_ROLE = 'admin/DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'admin/DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'admin/DELETE_ROLE_FAILURE';

export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT';
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';
export const DOWNLOAD_REPORT_FAILURE = 'DOWNLOAD_REPORT_FAILURE';

export const FETCH_EMPLOYEES = 'admin/FETCH_EMPLOYEES';
export const FETCH_EMPLOYEES_SUCCESS = 'admin/FETCH_EMPLOYEES_SUCCESS';
export const FETCH_EMPLOYEES_FAILURE = 'admin/FETCH_EMPLOYEES_FAILURE';

export const SYNC_ZOHO = 'admin/SYNC_ZOHO';
export const SYNC_ZOHO_SUCCESS = 'admin/SYNC_ZOHO_SUCCESS';
export const SYNC_ZOHO_FAILURE = 'admin/SYNC_ZOHO_FAILURE';
